import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  EditNotificationSettingMutation,
  EditNotificationSettingMutationVariables,
} from "../generated/graphql";

const EDIT_NOTIFICATION_SETTING_MUTATION = gql`
  mutation editNotificationSetting($input: EditNotificationSettingInput!) {
    editNotificationSetting(input: $input) {
      ok
      err
    }
  }
`;

export const useEditNotificationSetting = (
  onCompleted?: (data: EditNotificationSettingMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<
    EditNotificationSettingMutation,
    EditNotificationSettingMutationVariables
  >(EDIT_NOTIFICATION_SETTING_MUTATION, {
    onCompleted,
    onError,
  });
};
